export * from '@primeuix/themes/lara/inputgroup';
export { default } from '@primeuix/themes/lara/inputgroup';
